import { createAction, props } from '@ngrx/store';
import { ICourse } from '../models/course.model';
import { ILesson } from '../models/lesson.model';
import { LessonProgressStatus } from '../models/lesson-progress-status.model';

export const getCourseActivity = createAction('[Course] Get Course Activity', (courseId: string) => ({ courseId }));
export const getCourseActivitySuccess = createAction('[Course] Get Course Activity success', (learningCourse: ICourse) => ({ learningCourse }));
export const getCourseActivityFailure = createAction('[Course] Get Course Activity failure', props<{ error: string }>());

export const setCurrentLesson = createAction('[Course] Set Current Lesson', (lessonId: string) => ({ lessonId }));
export const setCurrentLessonSuccess = createAction('[Course] Set Current Lesson success', (currentLesson: ILesson) => ({ currentLesson }));
export const setCurrentLessonFailure = createAction('[Course] Set Current Lesson failure', props<{ error: string }>());

export const setCurrentLessonStatus = createAction('[Course] Set Current Lesson Status', (lessonId: string, status:LessonProgressStatus) => ({ lessonId, status }));
export const setCurrentLessonStatusSuccess = createAction('[Course] Set Current Lesson Status success', (course: ICourse, lessonId: string) => ({ course, lessonId }));
export const setCurrentLessonStatusFailure = createAction('[Course] Set Current Lesson Status failure', props<{ error: string }>());

export const clearCurrentLesson = createAction('[Course] Clear Current Lesson');

export const courseActions = {
    getCourseActivity,
    getCourseActivitySuccess,
    getCourseActivityFailure,
    setCurrentLesson,
    setCurrentLessonSuccess,
    setCurrentLessonFailure,
    setCurrentLessonStatus,
    setCurrentLessonStatusSuccess,
    setCurrentLessonStatusFailure,
    clearCurrentLesson

}
